import type { LoanTerm } from './types/LoanTerm';

export const isValidLoanTerm = (value: unknown): value is LoanTerm => {
  const loanTerms = [
    '24',
    '36',
    '48',
    '60',
    '72',
    '84',
    // enforce that the array contains all values of `LoanTerm`
  ] satisfies ReadonlyArray<LoanTerm>;

  return loanTerms.includes(value as LoanTerm);
};
